import * as Url from "./urls";
import Axios from "axios";
//Sku catalog

export const getSkucatlogCategory = (category) => {
  return Axios.get(`${Url.getSkucatlogCategory}?skuCatelog=${category}`);
};
export const billerSearch = (request) => {
  return Axios.post(Url.billerSearch, request);
};

//Mapping and Viewing

export const getCategory = () => {
  return Axios.get(Url.getCategory);
};
export const getSubCategory = (request) => {
  return Axios.get(Url.getSubCategory + request);
};
export const getSubCategoryMapping = (id, request) => {
  return Axios.post(Url.getSubCategoryMapping + id, request);
};
